import { render, staticRenderFns } from "./BindServerDialog.vue?vue&type=template&id=1c164701&"
import script from "./BindServerDialog.vue?vue&type=script&lang=js&"
export * from "./BindServerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports